import type { BlogPost } from "@/data/blogPosts";

/**
 * Generates a 1-3 word content-specific kicker for a blog post.
 * Priority: tools[0] > businessSolution keyword > title extraction
 */
export function getPostKicker(post: BlogPost): string {
  // 1. If the main tool is set, use it (most specific)
  if (post.tools && post.tools.length > 0) {
    const tool = post.tools[0];
    // Keep it short: max 3 words
    const words = tool.split(" ");
    return words.length <= 3 ? tool : words.slice(0, 3).join(" ");
  }

  // 2. Extract from title — take the most meaningful noun phrase
  const title = post.title;
  
  // Common patterns: "Tool: description" or "Tool — description"
  const colonSplit = title.split(/[:\—–]/);
  if (colonSplit.length > 1) {
    const first = colonSplit[0].trim();
    const words = first.split(" ");
    if (words.length <= 3) return first;
    return words.slice(0, 3).join(" ");
  }

  // Fallback: first 2-3 meaningful words from title
  const stopWords = ["el", "la", "los", "las", "un", "una", "de", "del", "en", "con", "por", "para", "que", "y", "o", "tu", "tus", "su", "sus", "como", "cómo", "ya", "no", "si", "más", "se", "es"];
  const meaningful = title
    .split(" ")
    .filter(w => !stopWords.includes(w.toLowerCase().replace(/[^a-záéíóúñü]/gi, "")))
    .slice(0, 3)
    .join(" ");

  return meaningful || post.category;
}
